import useDataCountry from "./useDataCountry";

export function useAmountFormatter(
    currency: string = 'USD',
    invalidResponse: string = 'Invalid Number',
) {
    const decimals: Record<string, {padding:number, seperator:string, decimalSeperator:string}> = {
        'JOD': {
            padding: 3,
            seperator:",",
            decimalSeperator:"."
        },
        'VND': {
            padding: 0,
            seperator:".",
            decimalSeperator:","
        }
    }
    return (amount: string | number, options?:{ccy?: string|null, round?: number}) => {
        const {ccy, round} = options?? {ccy: null, round:undefined}
        const numericValue = +amount
        const stringValue = `${round?numericValue.toFixed(round):numericValue}`
        
        if (isNaN(numericValue)) {
            return invalidResponse;
        }
        const [numberPart, decimalPart] = stringValue.split('.')
        return `${numberPart.replace(/\B(?=(\d{3})+(?!\d))/g, decimals[ccy??currency]?.seperator??',')
            }${decimals[ccy??currency]?.padding != 0 || decimalPart ? decimals[ccy??currency]?.decimalSeperator??'.' : ''}${(decimalPart ?? '').padEnd(decimals[ccy??currency]?.padding ?? 2, '0')
            }`
    }
}

export function roundingPrecision(nums:Array<number>){
    if (nums?.length == 0) return 0
    return Math.max(...nums.map((i)=>i?.toString()?.split('.')?.[1]?.length??0))
}